<app-notice-ui-notice-list
  *ngIf="isRenderable$ | async"
  [notices]="notices$ | async | defaultTo: []"
  (delete)="onDelete($event)"
></app-notice-ui-notice-list>
